import React from 'react'
import { Card } from 'react-bootstrap'
import { isDateValid, formatCurrency, payFrequencyToPaysPA } from '../../../helpers'
import ContactUsDialog from '../../dialog/contactUsDialog'
import { ImageBase64 } from '../../image/image'
import { Link } from 'react-router-dom'
import { ColoredBlock } from '@mmsg/louie'
import { Separator } from 'application/components/styledComponents/Separator'
import * as E from './estimateItemStyled'
import SpartaCustomerCount from './spartaCustomerCount'
import { ReactComponent as Flames } from '../../../images/flames.svg'
import { ReactComponent as EVBolt } from '../../../images/ev-bolt.svg'
import { IsVehicleElectric } from '../../../helpers'

export const EstimateItem = (props) => {
   const vehicleType = props.estimate && props.estimate.vehicleType === 'New' ? 'New' : 'Used'
  const vehicleName = props.estimate && props.estimate.vehicle.id
    ? `${vehicleType} ${props.estimate.vehicle.year} ${props.estimate.vehicle.make} ${props.estimate.vehicle.family}`
    : props.estimate.vehicleDescription

  let invalid
  if (
    props.proposal &&
    props.proposal.isValid === false &&
    props.proposal.quoteId == props.estimate.id
  ) {
    // Marks the estimate as inactive if proposal is invalid
    invalid = true
  } else if (
    props.proposal &&
    props.proposal.isValid &&
    props.proposal.quoteId
  ) {
    invalid = props.estimate.id != props.proposal.quoteId
  } else if (!props.estimate.isValid) {
    invalid = true
  } else {
    invalid = false
  }

  let userEmployer = props.userEmployer

  let leaseTerm = props.estimate && props.hasNonIntegralYearTerm
    ? props.estimate.leaseTerm.toString() + ' Months'
    : props.estimate.leaseTermYears.toString() + ' Years'

  let estimateDetailsURL = props.isConsultant
    ? '/consultant/estimates/' + props.estimate.id
    : '/estimates/' + props.estimate.id
  let notificationElement = document.getElementById('notification')
  if (notificationElement !== undefined && notificationElement !== null) {
    document.getElementById('notification').style.display = 'none'
  }

  let employerGRS = userEmployer && userEmployer.employerGRS 

  let isEVRebateApplicable = employerGRS && employerGRS.evRebateApplicable && IsVehicleElectric(props.estimate, false) && vehicleType !== 'Used'
  let evRebateValue = 0

  if(isEVRebateApplicable && employerGRS) 
    evRebateValue = employerGRS.evRebateValue
  
  let isExGST =
    employerGRS &&
    employerGRS.gstExclusiveDeductionsCode &&
    employerGRS.gstExclusiveDeductionsCode.toLowerCase() === 'yes'  

  let estimateCardHeaderText = () => {
    if(!(props.estimate && props.proposal))
      return ''

    if (!props.estimate.isValid || invalid) {
      return 'Estimate inactive'
    } else if (
      props.estimate.isValid &&
      props.proposal &&
      props.estimate.id === props.proposal.quoteId &&
      ((isDateValid(props.proposal.acceptedOn) &&
        !isDateValid(props.proposal.cancelledOn)) ||
        new Date(props.proposal.acceptedOn) >
          new Date(props.proposal.cancelledOn))
    ) {
      return 'Proposal accepted'
    } else if (
      props.estimate.isValid &&
      props.proposal &&
      props.estimate.id === props.proposal.quoteId &&
      (!isDateValid(props.proposal.acceptedOn) ||
        isDateValid(props.proposal.cancelledOn) ||
        new Date(props.proposal.cancelledOn) >
          new Date(props.proposal.acceptedOn))
    ) {
      return 'Proposal created'
    } else {
      return 'Enquiry Number #' + props.estimate.nlQuoteNumber
    }
  }

  let estimateCardHeaderClass = () => {
    if (invalid) {
      return 'estimate-item'
    } else {
      if (isSpartaVehicle) {
        return 'estimate-item highlight spartaHighlight'
      } else {
        return 'estimate-item highlight'
      }
    }
  }
  
  let isProposal = estimateCardHeaderText().startsWith('Proposal')

  let getLeaseType = () => {
    if(!(props.estimate && props.estimate.vehicle)) return ''
    if (props.estimate.vehicle.id) {
      if (
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('new')
      ) {
        return 'New Car Lease'
      } else if (
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('residual')
      ) {
        return 'Refinance Existing Lease'
      } else if (
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('leaseback')
      ) {
        return 'Lifestyle Lease'
      } else if (
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('private')
      ) {
        return 'Private Purchase Sale'
      } else {
        return 'Used Car Lease'
      }
    } else {
      if (
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('new')
      ) {
        return 'New Car Lease'
      } else if (
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('residual')
      ) {
        return 'Refinance Existing Lease'
      } else if (
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('leaseback')
      ) {
        return 'Lifestyle Lease'
      } else if (
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('private')
      ) {
        return 'Private Purchase Sale'
      } else {
        return 'Used Car Lease'
      }
    }
  }

  const vehicleDescriptionContent = [
    {
      heading: 'Vehicle Description',
      content: props.estimate && props.estimate.vehicleDescription || vehicleName,
    },
  ]

  let isSpartaVehicle =
    !invalid &&
    props.estimate &&
    props.estimate.vehicle &&
    props.estimate.vehicle.id &&
    props.estimate.vehicle.shadowPR &&
    props.estimate.vehicle.spartaDetail &&
    props.estimate.vehicle.spartaDetail.offerActive

  let spartaVehicleDetail = props.estimate && props.estimate.vehicle && props.estimate.vehicle.spartaDetail

  let GetFBTMethodText = () => {
    if(!props.estimate) return ''
    if (
      props.estimate.fbtMethod &&
      props.estimate.fbtMethod.toLowerCase().includes('cap') &&
      props.estimate.postTaxPerPay &&
      props.estimate.postTaxPerPay > 0
    ) {
      return 'CAP/ECM'
    } else if (
      props.estimate.fbtMethod &&
      props.estimate.fbtMethod.toLowerCase().includes('cap')
    ) {
      return 'CAP'
    } else {
      return props.estimate.fbtMethod
    }
  }

  let fbtMethodText = GetFBTMethodText()

  if (
    isSpartaVehicle &&
    spartaVehicleDetail &&
    !spartaVehicleDetail.offerActive
  ) {
    invalid = true
  }

  let line1
  let line2
  let icon
  if (isSpartaVehicle) {
    line1 = 'Limited availability!'

    if (
      spartaVehicleDetail &&
      spartaVehicleDetail.numberOfCustomerOffered > 5
    ) {
      line2 = spartaVehicleDetail.numberOfCustomerOffered + ' interested now'
      icon = <Flames />
    }
  } else if (isEVRebateApplicable) {
    line1 = 'This car may get you a ' + formatCurrency(evRebateValue, true) + ' EV Bonus!'
    icon = <EVBolt />
  }

  const CurrentCardHeader = isSpartaVehicle ? E.SpartaCardHeader : E.CardHeader
  let lifeOfLeaseSaving = props.estimate.totalSavingsITCsTaxVehicleGST > 0 ? props.estimate.totalSavingsITCsTaxVehicleGST : props.estimate.lifeOfLeaseTaxSaving

  const LeaseInfoEntry = ({ Id, Title, Value }) => {
    return (
      <>
        <E.LeaseInfoRow>
          <E.LeaseInfoTitle xs={6}>{Title}</E.LeaseInfoTitle>
          <E.LeaseInfoValue xs={6} id={Id}>
            {Value}
          </E.LeaseInfoValue>
        </E.LeaseInfoRow>
        <Separator />
      </>
    )
  }

  return props.isHidden && (!props.estimate.isValid || invalid) ? (
    <></>
  ) : (
    <E.EstimateItemStyled>
      <div className={estimateCardHeaderClass()}>
        <CurrentCardHeader
          invalid={invalid}
          id={'estimateitem' + props.index.toString() + '.cardheader'}
        >
          {estimateCardHeaderText()}
        </CurrentCardHeader>
        <div
          hidden
          id={'estimateitem' + props.index.toString() + '.nlquotenumber'}
        >
          {props.estimate.nlQuoteNumber}
        </div>
        <Card.Body>
          <div className="car-image">
            {props.estimate &&
              props.estimate.vehicle &&
              props.estimate.vehicle.id &&
              props.estimate.vehicle.vehicleImage && (
                <ImageBase64
                  invalid={invalid}
                  ImageBase64Encoded={
                    props.estimate.vehicle.vehicleImage.base64Image
                  }
                  id={'estimateitem' + props.index.toString() + '.vehicleimage'}
                />
              )}
            {props.estimate &&
              props.estimate.vehicle &&
              (!props.estimate.vehicle.id ||
                !props.estimate.vehicle.vehicleImage) && (
                <img
                  src="/images/car-image-default.svg"
                  alt=""
                  style={{ opacity: invalid ? 0.5 : 1 }}
                  id={'estimateitem' + props.index.toString() + '.defaultimage'}
                />
              )}
              {((isSpartaVehicle && !isProposal) || isEVRebateApplicable) && (
              <E.SpartaBlock
                id={'estimateitem' + props.index.toString() + '.infoblock'}
              >
                <SpartaCustomerCount
                  line1={line1}
                  line2={line2}
                  icon={icon}
                  extended={line2 == null}
                  spacingValue={1}
                />
              </E.SpartaBlock>
            )} 
            </div> 
          <E.ImageText>Image is indicative only</E.ImageText>
          <E.CarName
            headerHeight={props.headerHeight}
            id={'estimateitem' + props.index.toString() + '.vehiclename'}
          >
            {vehicleName}
          </E.CarName>
          <div className="text-center mt-4">
            <Link to={estimateDetailsURL} tabIndex={-1}>
              <E.EstimateItemPrimaryButton
                isSparta={isSpartaVehicle && !invalid}
                extendInMob
                id={'estimateitem' + props.index.toString() + '.viewdetails1'}
              >
                View Details
              </E.EstimateItemPrimaryButton>
            </Link>
          </div>

          <E.EstimateItemInfoBlock
            isSparta={isSpartaVehicle && !invalid}
            data={vehicleDescriptionContent}
            alignCenter={true}
            descFontWeight="normal"
            className="estimate-item__description"
            minHeight={props.vehicleDescHeight}
            id={'estimateitem' + props.index.toString() + '.cardescription'}
          />
          <Separator className="mt-3" />
           <LeaseInfoEntry
            Id={'estimateitem' + props.index.toString() + '.leasetype'}
            Title="Lease type"
            Value={getLeaseType()}
          />
          <div>
            {fbtMethodText && (
              <LeaseInfoEntry
                Id={'estimateitem' + props.index.toString() + '.fbtmethod'}
                Title="FBT Method"
                Value={fbtMethodText}
              />
            )}
            {props.estimate.productId && (
              <LeaseInfoEntry
                Id={'estimateitem' + props.index.toString() + '.productId'}
                Title={
                  global.config.isBrandMX
                    ? 'Lease Product Type'
                    : 'Your lease product type'
                }
                Value={props.estimate.productId
                  .replace('Novated Lease', '')
                  .trim()}
              />
            )}
            {props.estimate.priveawayPrice > 0 && (
              <LeaseInfoEntry
                Id={'estimateitem' + props.index.toString() + '.leaseprice'}
                Title={'Your ' + global.config.brand + ' Novated Lease Price'}
                Value={formatCurrency(props.estimate.priveawayPrice)}
              />
            )}
            <E.LeaseTermDiv>
              <div>Lease term</div>
              <h2 id={'estimateitem' + props.index.toString() + '.term'}>
                {leaseTerm}
              </h2>
            </E.LeaseTermDiv>
            <Separator />
            <E.TotalSalPackBlock>
              <div className="row-spacing text-center text-brand">
                <E.TotalSalPackTitle>
                  Total Salary Packaging Deductions
                </E.TotalSalPackTitle>
                {!isExGST && (
                  <b>
                    <div
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.totalpackageperpayincgsttaxshare'
                      }
                    >
                      {props.estimate.taxShare &&
                        props.estimate.taxShare.toLowerCase() == 'yes' &&
                        formatCurrency(
                          props.estimate.totalPackagePerPayExGSTTaxShare * 1.1
                        )}
                    </div>
                    <div
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.totalpackageperpayincgst'
                      }
                    >
                      {!props.estimate.taxShare ||
                        (props.estimate.taxShare &&
                          props.estimate.taxShare.toLowerCase() == 'no' &&
                          formatCurrency(
                            props.estimate.totalPackagePerPayIncGST
                          ))}
                    </div>
                  </b>
                )}
                {isExGST && (
                  <b>
                    <div
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.totalpackageperpayexgsttaxshare'
                      }
                    >
                      {props.estimate.taxShare &&
                        props.estimate.taxShare.toLowerCase() == 'yes' &&
                        formatCurrency(
                          props.estimate.totalPackagePerPayExGSTTaxShare
                        )}
                    </div>
                    <div
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.totalpackageperpayexgst'
                      }
                    >
                      {!props.estimate.taxShare ||
                        (props.estimate.taxShare &&
                          props.estimate.taxShare.toLowerCase() == 'no' &&
                          formatCurrency(
                            props.estimate.totalPackagePerPayExGST
                          ))}
                    </div>
                  </b>
                )}
              </div>

              <E.TotalSalPackText>
                Less estimated Tax and Medicare Levy savings per pay
              </E.TotalSalPackText>
              {props.estimate.taxandMedicareSavingsLifeofLease > 0  && 
                <div className="text-center mb-2 font-weight-bold">-{formatCurrency(props.estimate.taxandMedicareSavingsLifeofLease/props.estimate.leaseTerm * 12 / payFrequencyToPaysPA(userEmployer.payFrequency))}</div>
              }
              {props.estimate.taxandMedicareSavingsLifeofLease === 0  && 
                <div className="mb-2">&nbsp;</div>
              }
              <div className="row-spacing text-center">
                <E.EstOutOfPocket>Estimated out of pocket</E.EstOutOfPocket>
                <E.ColouredBlock>
                  
                  <h2
                    className="mb-2"
                    id={
                      'estimateitem' + props.index.toString() + '.outofpocket'
                    }
                  >
                    {formatCurrency(props.estimate.outOfPocketPerPay)}
                  </h2>
                  <div
                    id={
                      'estimateitem' + props.index.toString() + '.payfrequency'
                    }
                  >
                    {userEmployer && userEmployer.payFrequency}
                  </div>
                </E.ColouredBlock>
              </div>

              <E.TotalSalPackText>
                Package includes car finance, registration, running costs and
                more.
              </E.TotalSalPackText>
            </E.TotalSalPackBlock>

            <Separator />

            <E.EstSavingsBlock>
              <div>Your estimated savings</div>
              <h2 id={'estimateitem' + props.index.toString() + '.savings'}>
                {formatCurrency(lifeOfLeaseSaving)}
              </h2>
              <span className="text-small">Over life of lease</span>
            </E.EstSavingsBlock>

            <Separator className="mb-3" />
            <E.OnRoadBudgetBlock>
              <E.OnRoadTextItem isBold isPadded>
                Your on the road budget
              </E.OnRoadTextItem>

              <E.OnRoadTextItem isBold={global.config.isBrandRS}>
                You've estimated you'll drive:
              </E.OnRoadTextItem>
              <E.OnRoadTextItem
                id={'estimateitem' + props.index.toString() + '.kmperannum'}
                isBold={global.config.isBrandMX}
                isPadded
              >
                {props.estimate.kmPerAnnum} km/year
              </E.OnRoadTextItem>

              {!isExGST && (
                <div>
                  <E.OnRoadTextItem isBold>
                    Giving you a convenient on road budget of:
                  </E.OnRoadTextItem>
                  <E.OnRoadTextItem isPadded>
                    <span
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.runningcostperpayincgst'
                      }
                    >
                      {formatCurrency(props.estimate.runningCostsPerPayIncGST)}
                    </span>
                    {userEmployer && userEmployer.payFrequency && (
                      <span
                        id={
                          'estimateitem' +
                          props.index.toString() +
                          '.payfrequencyincgst'
                        }
                      >
                        /
                        {userEmployer && userEmployer.payFrequency.toString().replace('ly', '')}
                      </span>
                    )}
                  </E.OnRoadTextItem>
                </div>
              )}
              {isExGST && (
                <div className="mb-3">
                  <E.OnRoadTextItem isBold={global.config.isBrandRS}>
                    Giving you a convenient on road budget of:
                  </E.OnRoadTextItem>
                  <E.OnRoadTextItem isPadded isBold={global.config.isBrandMX}>
                    <span
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.runningcostperpayexgst'
                      }
                    >
                      {formatCurrency(props.estimate.runningCostsPerPayExGST)}
                    </span>
                    {userEmployer && userEmployer.payFrequency && (
                      <span
                        id={
                          'estimateitem' +
                          props.index.toString() +
                          '.payfrequencyexgst'
                        }
                      >
                        /
                        {userEmployer && userEmployer.payFrequency.toString().replace('ly', '')}
                      </span>
                    )}
                  </E.OnRoadTextItem>
                </div>
              )}

              <E.OnRoadTextItem isBold={global.config.isBrandRS} isPadded>
                Your total amount financed:
              </E.OnRoadTextItem>
              <E.OnRoadTextItem isBold={global.config.isBrandRS}>
                Giving you access to:
              </E.OnRoadTextItem>
              <E.TickList>
                <li>Potential tax benefits for the life of the lease</li>
                <li>No upfront costs on the car</li>
                <li>Your on the road budget</li>
                <li>Insurance options</li>
              </E.TickList>

              <E.OnRoadTextItem isBold={global.config.isBrandRS}>
                Total amount financed
              </E.OnRoadTextItem>
              <E.OnRoadTextItem
                isBig
                isBold
                isPadded
                id={'estimateitem' + props.index.toString() + '.financedamount'}
              >
                {formatCurrency(props.estimate.financeAmount)}
              </E.OnRoadTextItem>
              <E.OnRoadTextItem isBold={global.config.isBrandRS}>
                Total residual value
              </E.OnRoadTextItem>
              <E.OnRoadTextItem isBig isBold isPadded>
                <span
                  id={
                    'estimateitem' + props.index.toString() + '.residualamount'
                  }
                >
                  {formatCurrency(props.estimate.leaseResidualAmountIncGST)}
                </span>
                {global.config.isBrandMX && props.estimate.residualPCT && (
                  <span
                    id={
                      'estimateitem' +
                      props.index.toString() +
                      '.residualpercent'
                    }
                  >
                    {' '}
                    ({props.estimate.residualPCT}%)
                  </span>
                )}
              </E.OnRoadTextItem>
              {global.config.isBrandRS && props.estimate.residualPCT && (
                <>
                  <E.OnRoadTextItem isBold>
                    Residual percentage
                  </E.OnRoadTextItem>
                  <E.OnRoadTextItem isBig isBold isPadded>
                    <span
                      id={
                        'estimateitem' +
                        props.index.toString() +
                        '.residualpercent'
                      }
                    >
                      {props.estimate.residualPCT}%
                    </span>
                  </E.OnRoadTextItem>
                </>
              )}
            </E.OnRoadBudgetBlock>
          </div>
          <Separator className="mb-3" />
          <div className="mb-4 mt-2 text-center">
            <Link to={estimateDetailsURL} tabIndex={-1}>
              <E.EstimateItemPrimaryButton
                isSparta={isSpartaVehicle && !invalid}
                extendInMob
                id={'estimateitem' + props.index.toString() + '.viewdetails2'}
              >
                View Details
              </E.EstimateItemPrimaryButton>
            </Link>
          </div>
          <div className="text-center">
            {!props.isConsultant && (
              <ContactUsDialog
                className={
                  global.config.isBrandMX
                    ? 'link'
                    : 'link font-weight-bold text-underline'
                }
                theme="link"
                launchText="Contact your consultant"
              />
            )}
            {props.isConsultant && (
              <a
                className="link text-underline readonly"
                id="estimateitem.contactconsultant"
              >
                Contact your consultant
              </a>
            )}
          </div>

          <div className="text-center">
            {' '}
            Updated {new Date(props.estimate.updatedOn).toLocaleString('en-AU')}
          </div>
        </Card.Body> 
      </div>
    </E.EstimateItemStyled>
  )
}

export default EstimateItem
